/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompromisedDevice
 */
export interface CompromisedDevice {
    /**
     * 
     * @type {number}
     * @memberof CompromisedDevice
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    stealerType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    os?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    ip?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CompromisedDevice
     */
    infectionDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    zipFile?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CompromisedDevice
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CompromisedDevice
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    readonly leaks: string;
    /**
     * 
     * @type {string}
     * @memberof CompromisedDevice
     */
    readonly leaksCount: string;
}

/**
 * Check if a given object implements the CompromisedDevice interface.
 */
export function instanceOfCompromisedDevice(value: object): value is CompromisedDevice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('leaks' in value) || value['leaks'] === undefined) return false;
    if (!('leaksCount' in value) || value['leaksCount'] === undefined) return false;
    return true;
}

export function CompromisedDeviceFromJSON(json: any): CompromisedDevice {
    return CompromisedDeviceFromJSONTyped(json, false);
}

export function CompromisedDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompromisedDevice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'deviceId': json['device_id'] == null ? undefined : json['device_id'],
        'stealerType': json['stealer_type'] == null ? undefined : json['stealer_type'],
        'country': json['country'] == null ? undefined : json['country'],
        'os': json['os'] == null ? undefined : json['os'],
        'ip': json['ip'] == null ? undefined : json['ip'],
        'infectionDate': json['infection_date'] == null ? undefined : (new Date(json['infection_date'])),
        'zipFile': json['zip_file'] == null ? undefined : json['zip_file'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'leaks': json['leaks'],
        'leaksCount': json['leaks_count'],
    };
}

  export function CompromisedDeviceToJSON(json: any): CompromisedDevice {
      return CompromisedDeviceToJSONTyped(json, false);
  }

  export function CompromisedDeviceToJSONTyped(value?: Omit<CompromisedDevice, 'id'|'created_at'|'updated_at'|'leaks'|'leaks_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
        'stealer_type': value['stealerType'],
        'country': value['country'],
        'os': value['os'],
        'ip': value['ip'],
        'infection_date': value['infectionDate'] == null ? undefined : ((value['infectionDate'] as any).toISOString()),
        'zip_file': value['zipFile'],
    };
}

